import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchEvent } from 'api/events';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { eventQueryKeys } from 'queries/event-query-keys';

const useCurrentCampaignEvent = () => {
    const { data: campaign } = useCurrentCampaign();

    return useSuspenseQuery({
        queryKey: eventQueryKeys.event(campaign.id),
        queryFn: () => fetchEvent(campaign.id),
    });
};

export { useCurrentCampaignEvent };
